import React from "react";

/**
 * Leads: a target with an arrow in it, so Leads no longer shares the Clients
 * icon. Same props and sizing contract as ClientsIcon (18 x 18 viewBox,
 * colour from `fill`), drawn as strokes in that colour.
 */
export default function LeadsIcon(props?: any) {
  const svgStyles: any = {
    width: props?.width ? props.width : null,
    height: props?.height ? props.height : null,
    fill: props?.fill ? props.fill : null,
    margin: props?.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  const color = filteredStyles.fill ?? "currentColor";

  // The nav's active/hover style forces `svg` and every `path` to
  // fill: white !important (right for the filled icons, wrong for this
  // outline one - it turned the target into a solid blob, 2026-10-05).
  // So: no <path> elements, and every ring/arrow carries fill="none" as
  // its own attribute, which wins over the inherited svg fill. Only the
  // bullseye dot is meant to be filled.
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      style={{ ...filteredStyles, fill: "none" }}
      className={props?.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="10" r="6.4" fill="none" stroke={color} strokeWidth={1.1} />
      <circle cx="8" cy="10" r="3.5" fill="none" stroke={color} strokeWidth={1.1} />
      <circle cx="8" cy="10" r="1.2" fill={color} />
      {/* Arrow stuck in the bullseye: shaft from the center, two swept-back
          feathers at the tail. */}
      <line x1="8" y1="10" x2="16.2" y2="1.8" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
      <polyline points="13.6,2.4 13.6,4.4 15.6,4.4" fill="none" stroke={color} strokeWidth={1.1} strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="15,1 15,3 17,3" fill="none" stroke={color} strokeWidth={1.1} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
